import { put, takeLatest } from "redux-saga/effects";
import VoucherActions, {
  Types as VoucherTypes,
} from "../../stores/voucher/Actions";

function* getVoucher(request) {
  const voucherDataInfo = request.payload;
  yield put(VoucherActions.getVoucherLoading());
  yield put(VoucherActions.getVoucherSuccess({ voucherDataInfo }));
}

function* getVoucherGmm(request) {
  const voucherGmmDataInfo = request.payload;
  yield put(VoucherActions.getVoucherGmmLoading());
  yield put(VoucherActions.getVoucherGmmSuccess({ voucherGmmDataInfo }));
}

const exportedArray = [
  takeLatest(VoucherTypes.GET_VOUCHER, getVoucher),
  takeLatest(VoucherTypes.GET_VOUCHER_GMM, getVoucherGmm),
];

export default exportedArray;
